import { useContext, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import * as Icon from "react-bootstrap-icons";
import { AppStateContext } from "../Context/contextState";
import { useNavigate } from "react-router-dom";
import img1 from "../assets/img1.png";
import Loading from "../GelobalComponents/Loading";
import "./LoginPage.css";

export default function LogIn() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [err, setErr] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const { loading, setLoading } = useContext(AppStateContext);
  const navigate = useNavigate();

  useEffect((e) => {
    if (localStorage.getItem("token")) {
      navigate("/projects");
    } else {
      const savedUsername = localStorage.getItem("username");
      const savedPassword = localStorage.getItem("password");
      const savedRememberMe = localStorage.getItem("rememberMe");
      if (savedRememberMe === "true" && savedUsername && savedPassword) {
        setUsername(savedUsername);
        setPassword(savedPassword);
        setRememberMe(true);
      }
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(  
        // "http://80.210.22.220:5003/api/auth/login",
       
        "https://3dbuilding.parisashahbazi.com/api/auth/login",
        // "https://api.ifc.mirzaeei.com/api/auth/login",
        // "https://api.mirzaeei.com/api/auth/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization:
              "Bearer 3|zh6OxTQJ2yH7B69Nv8PKVwwopplwiX7CtRn9mccpb8a549d3",
          },
          body: JSON.stringify({ username, password }),
        }
      );
      const data = await response.json();

      if (response.ok) {
        if (rememberMe) {
          localStorage.setItem("username", username);
          localStorage.setItem("password", password);
          localStorage.setItem("rememberMe", "true");
        } else {
          localStorage.removeItem("username");
          localStorage.removeItem("password");
          localStorage.removeItem("rememberMe");
        }
        localStorage.setItem("token", data.info.token);
        navigate("/projects");
      } else {
        setErr(data.message || "خطا در ورود");
      }
    } catch (err) {
      console.error("Error:", err);
      setErr("خطا در ورود");
    }
  };

  return (
    <>
      <main>
        <div className="Form-container">
          <Form className="Login-form" onSubmit={handleSubmit}>
          <p className="infoP">This is a version of the test for you on my personal host, not my client's main project. Please do not upload a lot of heavy files.</p>
          <p className="infoT"> Username : admin1234 <br/> Password : Code_123456</p>

            <div className="Form-logo">
              <img src={img1} alt="logo" />
            </div>
            <div className="Form-title mb-5">
              <h1>ورود</h1>
            </div>
            <InputGroup className="mb-3" dir="ltr">
              <Form.Control
                placeholder="نام کاربری"
                aria-label="Username"
                aria-describedby="basic-addon1"
                className="Login-form-username-input"
                onChange={(e) => setUsername(e.target.value)}
                required
                dir="rtl"
                value={username}
              />
              <InputGroup.Text id="basic-addon1" className="Input-group-icon">
                <Icon.PersonCircle color="#364EA8" />
              </InputGroup.Text>
            </InputGroup>

            <InputGroup className="mb-3" dir="ltr">
              <div
                onClick={() => setShowPassword(!showPassword)}
                style={{ cursor: "pointer" }}
                className="Input-eye-icon"
              >
                {showPassword ? (
                  <Icon.EyeSlashFill color="#1E56A0" />
                ) : (
                  <Icon.EyeFill color="#1E56A0" />
                )}
              </div>
              <Form.Control
                placeholder="رمز عبور"
                type={showPassword ? "text" : "password"}
                aria-label="Password"
                aria-describedby="basic-addon2"
                className="Login-form-password-input"
                onChange={(e) => setPassword(e.target.value)}
                required
                dir="rtl"
                value={password}
              />
              <InputGroup.Text id="basic-addon1">
                <Icon.ShieldLockFill color="#364EA8" />
              </InputGroup.Text>
            </InputGroup>

            {err && <p className="Error-message">{err}</p>}

            <Form.Group
              className="mb-3"
              controlId="formBasicCheckbox"
              dir="rtl"
            >
              <Form.Check
                type="checkbox"
                label="مرا به خاطر بسپار"
                className="Remind-me"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
            </Form.Group>

            <div className="Submit-btn">
              <Button variant="primary" type="submit">
                ورود
              </Button>
            </div>

          </Form>
        </div>
        {loading && <Loading />}
      </main>
    </>
  );
}
